<template>
  <div class="swiper-container">
    <!-- <div class="nav_bar">
      <div class="logo">
        <img src="../../../assets/home/logo.png" alt="" />
      </div>
      <ul>
        <li><a href="#page1">关于INDIBA</a></li>
        <li><a href="#page2">产品方案</a></li>
        <li><a href="#page3">INDIBA资讯</a></li>
        <li><a href="#page3">找到INDIBA</a></li>
      </ul>
      <div class="concact_tel">
        <a href="tel://010 85951863">010 85951863</a>
      </div>
    </div> -->
    <div class="swiper-wrapper">
      <swiper :options="swiperOptions" ref="mySwiper" style="height: 100%">
        <swiper-slide>
          <img
            class="swiper-img"
            src="../../../assets/home/mobile/first_bg01.png"
            alt=""
          />
          <div class="swiper-des">
            <p>INDIBA<sup>®</sup>1983年至今</p>
            <p>专注人体健康与美学</p>
            <p>
              在中国，超过2000家机构选择。INDIBA为顾客带来舒适的自然健康美丽享受
            </p>
            <span class="more-content"
              ><i class="ri-arrow-right-circle-line"></i>探索更多内容</span
            >
          </div>
        </swiper-slide>
        <swiper-slide style="position: relative">
          <img
            class="swiper-img"
            src="../../../assets/home/mobile/first_bg02.png"
            alt=""
          />
          <div class="swiper-des">
            <p>INDIBA<sup>®</sup></p>
            <p>专业运动员的坚定盟友</p>
            <p>迅速恢复体能状态、预防损伤、伤后修复</p>
            <span class="more-content"
              ><i class="ri-arrow-right-circle-line"></i>探索更多内容</span
            >
          </div>
        </swiper-slide>
        <swiper-slide>
          <img
            class="swiper-img"
            src="../../../assets/home/mobile/first_bg03.png"
            alt=""
          />
          <div class="swiper-des">
            <p>INDIBA<sup>®</sup>以科技之力，焕活健康自然之美</p>
            <span class="more-content"
              ><i class="ri-arrow-right-circle-line"></i>探索更多内容</span
            >
          </div>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
  </div>
</template>

<script>
import "vue-awesome-swiper/node_modules/swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  name: "app",
  components: {
    swiper,
    swiperSlide,
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  data() {
    return {
      swiperOptions: {
        loop: true,
        autoplay: {
          delay: 5000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: false,
        },
      },
    };
  },
  methods: {
    slidePrev() {
      console.log("prev...");
      this.swiper.slidePrev();
    },
    slideNext() {
      console.log("next...");
      this.swiper.slideNext();
    },
  },
};
</script>

<style lang="less" less="scoped">
.swiper-container {
  height: 100%;
  position: relative;

  // position: relative;
  .swiper-img {
    width: 100vw;
    height: 100vh;
    position: relative;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
      margin: auto;
    z-index: -1;
  }
  .swiper-des {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 2rem;
    p {
      font-size: 1.5rem;
      margin: 0;
      letter-spacing: 0.1rem;
    }
    P:nth-child(3) {
      margin-top: 1.5rem;
      font-size: 0.8rem;
    }
    .more-content {
      display: flex;
      align-items: center;
      height: 4rem;
      font-size: 1rem;
      i {
        font-size: 1.8rem;
        margin-right: 0.2rem;
      }
    }
  }
}

// img {
//   width: 100%;
//   height: 100%;
// }

.swiper-pagination {
  .swiper-pagination-bullet {
    opacity: 1;
    background-color: rgba(255, 255, 255, 0.39);
  }
  .swiper-pagination-bullet-active {
    background-color: #fff;
  }
}
</style>
